module.exports = __webpack_public_path__ + "img/SeekerLogo2.30feab07.png";